import { RootState } from 'types';

export const notificationsSelector = (state: RootState) => state.notifications;
